import React from 'react';
import { PIPELINE_STEPS } from '../../config/constants';
import { normalizePipelineStatus, getPipelineIndex } from '../../utils/submissions';

const PipelineProgress = ({ currentStatus, liveListingUrl = null }) => {
  const steps = PIPELINE_STEPS;
  const normalized = normalizePipelineStatus(currentStatus);
  if (normalized === "rejected") {
    return (
      <p style={{ color: "var(--danger)", fontWeight: 600, margin: 0 }}>
        <i className="fas fa-times-circle"></i> This listing was rejected.
      </p>
    );
  }
  const activeIndex = getPipelineIndex(currentStatus);
  const progressPct = steps.length > 1
    ? (activeIndex / (steps.length - 1)) * 100
    : 0;

  return (
    <div className="pipeline-wrap">
      <div className="pipeline" role="list" aria-label="Listing pipeline progress">
        <div className="pipeline-rail" aria-hidden="true">
          <div className="pipeline-rail-fill" style={{ width: `${progressPct}%` }} />
        </div>
        <div className="pipeline-steps">
          {steps.map((step, i) => {
            const isDone = i < activeIndex;
            const isActive = i === activeIndex;
            const dotClass = isDone ? "completed" : isActive ? "active" : "";
            const showLiveLink = step.key === "live" && liveListingUrl;
            return (
              <div key={step.key} className={`pipeline-step ${dotClass}`} role="listitem">
                <div className={`pipeline-dot ${dotClass}`} aria-current={isActive ? "step" : undefined}>
                  <i className={`fas ${step.icon}`} aria-hidden="true"></i>
                </div>
                <div className="pipeline-caption">
                  <div className={`pipeline-label ${dotClass}`}>{step.label}</div>
                  <div className="pipeline-step-extra">
                    {showLiveLink ? (
                      <a
                        href={liveListingUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pipeline-live-link"
                        title="Open this listing on the public site"
                      >
                        View listing <i className="fas fa-external-link-alt" aria-hidden="true"></i>
                      </a>
                    ) : (
                      <span className="pipeline-step-spacer" aria-hidden="true" />
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PipelineProgress;
